import React, { useState, useRef, useEffect } from 'react'
import { Spin, Alert, Card } from 'antd'
import { Document, Page, pdfjs } from 'react-pdf'
import './PdfViewModal.less'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`; 

interface PDFPreviewModalProps {
  fileName: string | null
  fileUrl: string | null
  onCancel: () => void
}

const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({ fileName, fileUrl }) => {
  const [numPages, setNumPages] = useState<number | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width)
      }
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages)
    setLoading(false)
  }

  const onDocumentLoadError = () => {
    setLoading(false)
    setError(true)
  }

  return (
    <Card 
      title={`【${fileName}】预览`}
      style={{ top: 20, width: '100%' }}
    >
      {error ? (
        <Alert message="加载 PDF 文件失败" type="error" showIcon />
      ) : (
        <>
          {loading && (
            <div className="pdf-loading-wrap">
              <Spin size="large" />
            </div>
          )}
          {fileUrl && (
            <div className="pdf-doc-wrap" ref={containerRef}>
              <Document
                file={fileUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={containerWidth || undefined}
                    devicePixelRatio={window.devicePixelRatio}
                  />
                ))}
              </Document>
            </div>
          )}
        </>
      )}
    </Card>
  )
}

export default PDFPreviewModal